var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.246,
    height: 20.053,
    viewBox: "0 0 20.246 20.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.d{fill:none;}.a,.b{stroke:#162d43;stroke-linecap:round;stroke-width:3px;}.a{stroke-linejoin:round;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 8.928,
    cy: 8.928,
    r: 8.928
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8.928,
    cy: 8.928,
    r: 7.428
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.224.23l3.1,2.907",
    transform: "translate(14.803 14.796)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.56709608197737057c1657bad7e547d3.svg";
export { ForwardRef as ReactComponent };